export default "__VITE_ASSET__D2yF71L3__"